var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
      opId:"128",
      name:"角色授权明细",
      parentId:"TEAM_ID",
      parentName:"角色授权(按角色)",
      parentPath:"/system/userGroupAjs",
      dataClass:2,
      addClick: _vm.addClick
    }}}),_c('m-selectorcc',{attrs:{"visible":_vm.select,"select":{
    searchslotType: "",
    searchslottitle: "请选择权限",
    multiple: true,
    searchslotId: 125,
    searchslotkey: { ID: "ID" },
    filterWhere:_vm.$route.query.TEAM_ID,//过滤
    colname:"ajssqxzqx",
  }},on:{"update:visible":function($event){_vm.select=$event},"listenEvent":_vm.fn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }